
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.5 27.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.2 7.8h-.8c0-.8-.8-2-.8-2.3-.8-1.9-2-4.7-3.5-5.4-4.3-2.3-5.1 5.8-6.6 7.8-1.5.2-3.1.3-4.6.3-1.6 0-3.9.4-4.7 1.9s.8 3.1 2 3.9 2 1.6 2.7 2c.4.4 1.2.8 1.6 1.2.1.4-.1.9-.4 1.2-.4 1-.7 2-.8 3.1-.4 1.6-1.2 3.5 0 5.1s3.9 1.2 5.8.4c.9-.6 1.8-1.1 2.7-1.5.4-.4.8-.8 1.2-.8l.4-.4h.3c.4 0 .8.4 1.2.4.9.6 1.8 1.1 2.7 1.6 1.2 1 2.8 1.4 4.3 1.2 3.9-1.2.8-7 0-9.4 0-.4-.4-.8 0-.8.3-1 1-1.8 2-2.3 1.2-1.2 3.1-2.3 3.5-4.3 1.2-3.7-6.6-2.9-8.2-2.9z","fill":"#ddd"}})])
          )
        }
      }
    